// React bindings for utils/notificationLog (OPUS-1527).
//
// Two selectors over one listener list, which is what keeps the footer cheap:
//
//   useNotificationSummary() — the bell. Returns a cached {unread, topSeverity}
//     that the store only replaces when one of those values actually moves, so
//     useSyncExternalStore's Object.is bail-out means a push that changes
//     neither re-renders nothing at all.
//
//   useNotifications() — the panel, which is unmounted while closed. The entries
//     array does get a fresh reference per mutation, so this one re-renders on
//     every push; that is fine precisely because nothing subscribes to it unless
//     the operator has the tray open.
//
// Deliberately not a React context: SessionContext builds an unmemoised value
// object every render and re-renders every consumer with it, and a new context
// here would inherit that. A module singleton with subscribe() is the house
// pattern anyway (commandLog, allFixturesLive.service, useDDSConnection).
import { useSyncExternalStore } from 'react';
import {
  subscribeNotifications,
  getNotificationsSnapshot,
  getSummarySnapshot,
} from '../utils/notificationLog';

export function useNotificationSummary() {
  return useSyncExternalStore(
    subscribeNotifications,
    getSummarySnapshot,
    getSummarySnapshot,
  );
}

export function useNotifications() {
  return useSyncExternalStore(
    subscribeNotifications,
    getNotificationsSnapshot,
    getNotificationsSnapshot,
  );
}
